import { Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { ofType, StateObservable } from 'redux-observable';
import api from '../../core/api';
import { catchError, map, mergeMap } from 'rxjs/internal/operators';
import { AjaxError, AjaxResponse } from 'rxjs/internal/observable/dom/AjaxObservable';
import RequestFailed from '../../core/events/RequestFailed';
import State from 'src/application/core/State';
import { AjaxBackend } from '../../testHelpers/fakeBackendFactory';
import OrderDocumentRequested from '../events/OrderDocumentRequested';
import OrderDocumentGetSucceed from '../events/OrderDocumentGetSucceed';
import OrderDocumentGetFailed from '../events/OrderDocumentGetFailed';

export default (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> => {
    return event$.pipe(
        ofType(OrderDocumentRequested.type),
        mergeMap((event: OrderDocumentRequested) => {
            return backend.get(`${api()}users/${event.customerId}/documents/${event.documentType}/${event.documentId}`).pipe(
                map((ajaxResponse: AjaxResponse) => {
                    const linkSource = `data:${ajaxResponse.response.extension};base64,${ajaxResponse.response.body}`;
                    const downloadLink = document.createElement('a');
                    const fileName = `${event.documentType}.${ajaxResponse.response.extension}`;

                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                    return new OrderDocumentGetSucceed();
                }),
                catchError((e: AjaxError) =>
                    of(new OrderDocumentGetFailed(event.documentType, event.documentId), new RequestFailed(e.status))
                )
            );
        })
    );
};



// WEBPACK FOOTER //
// ./src/application/order/epic/orderGetDocument.ts